import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {getTemplate} from "../../actions/ApiCalls";
import NewsStory from "./NewsStory";
import NewsStory2 from "./NewsStory2";
import CustomNewsStory from "./CustomNewsStory";

function NewsPosts() {
    const {slug} = useParams<{ slug?: string }>();
    const [template, setTemplate] = useState<any>({});

    useEffect(() => {
        fetchTemplate()
    }, []);

    function fetchTemplate() {
        if (slug) {
            getTemplate(slug)
                .then(response => {
                    if (response.data.template_id) {
                        setTemplate(response.data.template_id);
                    }
                    else {
                        setTemplate(response.data.template_id.template_id);
                    }


                }).catch(error => {
                console.error("Failed to fetch template:", error);
            })
        }
    }

    useEffect(() => {
        getLayout();
    }, [template]);

    function getLayout() {
        if (slug) {

            switch (Number(template)) {
                case 1: return <NewsStory slug={slug}/>;
                case 2: return <NewsStory2 slug={slug}/>;
                case 3: return <CustomNewsStory slug={slug}/>;
            }
        }

    }





    return <div>{getLayout()}</div>
}

export default NewsPosts;
